<div class="row p-3">
  <div class="col-lg-6 col-md-6 col-sm-6">
    <div>ชนิดป้าย :</div>
    <div>
      <!-- <kendo-combobox class="w-100" [data]="sign_type_list" [allowCustom]="allowCustom" [textField]="'name'"
          [valueField]="'id'" [value]="search_sign_type" (valueChange)="handleValueSignType($event)"
          [placeholder]="'ทั้งหมด'" [filterable]="true">
        </kendo-combobox> -->
      <input autocomplete="nope" type="text" placeholder="" maxlength="100" class="k-textbox form-control w-100"
        [(ngModel)]="search_sign_type" [ngModelOptions]="{standalone: true}" />
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6">
    <div>อัตราส่วน :</div>
    <div>
      <kendo-combobox class="w-100" [data]="data_ratio" [allowCustom]="allowCustom" [textField]="''" [valueField]="''"
        [value]="search_ratio" (valueChange)="handleValueRatio($event)" (filterChange)="handleFilterRatio($event)"
        [placeholder]="'ทั้งหมด'" [filterable]="true">
      </kendo-combobox>
    </div>
  </div>

  <div class="col-lg-12 col-md-12 d-flex align-items-end justify-content-end">
    <div class="mt-1">
      <button type="button" (click)="search()" class="btn btn-primary pull-right text-white ml-1"> <i
          class="fa fa-search"></i>
        ค้นหา </button>
    </div>
  </div>

  <div class="col-12 mt-3 table-header pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between">
    <div class="font-2">
      <i class="fa fa-clone mr-2"></i> ชนิดป้าย
    </div>
    <div>
      <button *ngIf="isAdd" (click)="openAddModal()" type="button" class="btn btn-primary text-white ml-1"> <i class="fa fa-plus"></i>
        เพิ่มชนิดป้าย</button>
    </div>


  </div>
  <div class="col-12 mt-3">
    <table class="table table-outline mb-0">
      <thead class="thead-dark" style="background-color: black;">
        <tr>
          <th class="text-center text-light table-header"><i class="fa fa-hashtag"></i></th>
          <th class="text-center text-light table-header">สถานะ</th>
          <th class="text-center text-light table-header">ชนิดป้าย</th>
          <th class="text-center text-light table-header">ขนาด</th>
          <th class="text-center text-light table-header">อัตราส่วน</th>
          <th class="text-center text-light table-header">วันที่แก้ไขล่าสุด</th>
          <th *ngIf="isEdit" class="text-center text-light table-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!this.is_loading && data_list?.length == 0">
          <td colspan="10" style="height: 50px;">
            ไม่พบข้อมูล
          </td>
        </tr>
        <tr *ngIf="this.is_loading">
          <td colspan="10" style="height: 50px;">
            กำลังโหลด ..
          </td>
        </tr>
        <tr *ngFor="let item of data_list;index as i;">
          <td class="text-center">
            <div>
              {{(i+1)+((this.currentPage - 1)*itemsPerPage)}}
            </div>
          </td>
          <td class="text-center">
            <i tooltip="Active" placement="top" *ngIf="item?.status == statusEnum.Active"
              class="fa fa-circle text-success"></i>
            <i tooltip="Inctive" placement="top" *ngIf="item?.status == statusEnum.Inactive"
              class="fa fa-circle text-danger"></i>
          </td>
          <td class="text-center">
            {{item?.name}}
          </td>
          <td class="text-center">
            {{item?.width}}:{{item?.height}}
          </td>
          <td class="text-center">
            {{item?.aspect_ratio}}
          </td>
          <td class="text-center">
            <div style="font-size: 12px;">{{item?.lastupdate_date | date: 'yyyy.MM.dd HH:mm'}}</div>
          </td>
          <td *ngIf="isEdit" class="text-center">
            <div class="d-flex align-items-center justify-content-center">
              <button (click)="openEditModal(item)" title="แก้ไข" type="button"
                class="btn btn-sm btn-warning mr-1 text-light">
                <i class="cui-note icons"></i>
              </button>
              <button (click)="openDeleteModal(item)" title="ลบ" type="button" class="btn btn-sm btn-danger ml-1">
                <i class="cui-trash icons"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="12" class="table-footer">
            <div class="table-footer-inside d-flex align-items-center justify-content-between">
              <div class="ml-3 pt-3">
                <pagination [totalItems]="totalItems" [maxSize]="5" [itemsPerPage]="itemsPerPage"
                  [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)" class="pagination"
                  previousText="&lsaquo;" nextText="&rsaquo;" [boundaryLinks]="true" firstText="&laquo;"
                  lastText="&raquo;"></pagination>
              </div>
              <div></div>
              <div class="mr-3 ml-2">total: {{totalItems}}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- <div class="col-12 table-panel-body-height scrollbar-style">
  
    </div>
    <div class="col-12 p-0 table-header d-flex align-items-center justify-content-between">
      <div class="mr-2 ml-3">
        <pagination [totalItems]="totalItems" [maxSize]="5" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage"
          (pageChanged)="pageChanged($event)" class="pagination p-0 m-0" previousText="&lsaquo;" nextText="&rsaquo;"
          [boundaryLinks]="true" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div></div>
      <div class="mr-3 ml-2">total: {{totalItems}}</div>
    </div> -->
</div>

<div bsModal #addModal="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true" (onHide)="clearData()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i><span *ngIf="!selectItem?.id">เพิ่มชนิดป้าย</span><span
            *ngIf="selectItem?.id">แก้ไขชนิดป้าย</span></h4>
        <button type="button" class="close text-light" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="form-horizontal mt-2 mb-2">
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"> <span
                class="float-sm-left float-md-right">ชื่อชนิดป้าย
                :</span></label>
            <div class="col-md-9">
              <input type="text" [(ngModel)]="selectItem.name" class="form-control" placeholder="" maxlength="50"
                [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">กว้าง
                (pixel)
                :</span></label>
            <div class="col-md-3">
              <input type="text" [(ngModel)]="selectItem.width" name="text-input-width" class="form-control"
                placeholder="" maxlength="10" numbersOnly>
            </div>
            <label class="col-md-3 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">ยาว
                (pixel)
                :</span></label>
            <div class="col-md-3">
              <input type="text" [(ngModel)]="selectItem.height" name="text-input-height" class="form-control"
                placeholder="" maxlength="10" numbersOnly>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"> <span
                class="float-sm-left float-md-right">อัตราส่วน
                :</span></label>
            <label class="col-md-3 col-form-label" for="text-input"> <span>{{btAspectRatio}}</span></label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"> <span class="float-sm-left float-md-right">Pit
                (mm)
                :</span></label>
            <div class="col-md-3">
              <input type="text" [(ngModel)]="selectItem.pit" name="text-input-pit" class="form-control" placeholder=""
                maxlength="10" numbersOnly>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="select1"> <span class="float-sm-left float-md-right">สถานะ
                :</span></label>
            <div class="col-md-9">
              <kendo-combobox class="w-100" [data]="status_list" [allowCustom]="allowCustom" [textField]="'name'"
                [valueField]="'id'" [value]="status_modal" (valueChange)="handleValueStatusModal($event)"
                [placeholder]="'โปรดระบุ'" [filterable]="true">
              </kendo-combobox>
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary" (click)="addModal.hide()">ยกเลิก</button>
          <button
            [disabled]="!(selectItem.name && status_modal != null && selectItem.width != null&& selectItem.height != null&& selectItem.pit != null)"
            *ngIf="selectItem?.id" type="button" class="btn btn-primary text-white ml-2"
            (click)="editSignType()">แก้ไข</button>
          <button
            [disabled]="!(selectItem.name && status_modal != null && selectItem.width != null&& selectItem.height != null&& selectItem.pit != null)"
            *ngIf="!selectItem?.id" type="button" class="btn btn-primary text-white ml-2"
            (click)="addSignType()">เพิ่ม</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div bsModal #deleteModal="bs-modal" class="modal fade modal-md" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" (onHide)="clearData()" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark bg-gray-900">
        <h4 class="modal-title"> <i class="icon-info mr-2"></i>ลบชนิดป้าย</h4>
        <button type="button" class="close text-light" (click)="deleteModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <h4>คุณต้องการลบใช่หรือไม่</h4>
        </div>
        <div class="mt-2 mb-4 text-center">
          <h4>{{selectItem?.name}}</h4>
        </div>
        <div class="d-flex justify-content-end mt-2 mb-2">
          <button type="button" class="btn btn-secondary mr-1" (click)="deleteModal.hide()">ยกเลิก</button>
          <button type="button" class="btn btn-primary text-white ml-1" (click)="deleteSignType()">ยืนยัน</button>
        </div>

      </div>
    </div>
  </div>
</div>
<swal #swalSuccess title="<div class='text-light'>สำเร็จ</div>" type="success" text="" icon="success"></swal>
<swal #swalError title="<div class='text-light'>ไม่สำเร็จ</div>" html="<div class='text-light'>{{res_message}}</div>"
  type="error" icon="error"></swal>